import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  Product,
} from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { UntypedFormArray } from '@angular/forms';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ProductDao } from '@app/dao/product/product.dao';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'code-parrainage-form',
    templateUrl: './code-parrainage-form.component.html',
    styleUrls: ['./code-parrainage-form.component.scss'],
    standalone: false
})
export class CodeParrainageFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;
  products: Product[] = [];
  rcdaComparedProductsChoices: Product[] = [];
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  organizationId: number;
  productType: string;
  productIds: number[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
    protected attributionDao: AttributionDao,
  ) {
    super(formConstructor);
  }

  getProductsAvailableForParrainage(products, parameters, productType) {
    let productIds = [];

    if (parameters?.subscriberType === 'COMPANY') {
      return productIds;
    }

    if (['CONTRAT_CAPI', 'PER'].includes(productType)) {
      return productIds;
    }

    if (
      productType === 'SCPI' &&
      ['USUFRUIT', 'NU_PROPRIO'].includes(parameters?.scpiOwnershipType)
    ) {
      return productIds;
    }

    for (let product of products) {
      if (
        product?.parameters?.computedInitialInvestmentAmount > 2000 &&
        product?.parameters?.partnerFlux === 'CORUM'
      ) {
        productIds.push(product?.productId);
      }
    }

    return productIds;
  }

  ngOnInit(): void {
    const pledge = this.subscriptionFacade.getPledge();
    const {
      products = [],
      parameters = {} as Parameters,
      productType = 'SCPI',
    } = pledge || {};
    const productIds = this.getProductsAvailableForParrainage(
      products,
      parameters,
      productType,
    );

    const matchingProducts = this.getMatchingProducts(productIds, products);
    this.products = matchingProducts || [];
    this.productIds =
      matchingProducts?.map(product => product?.productId) || [];

    this.initForm(pledge?.products || []);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(this, 'products');
    }
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(
        this,
        'products',
        false,
        this.nextStep.bind(this),
        true,
      );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }

  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }

  getMatchingProducts(
    questionIds: number[],
    productList: Product[],
  ): Product[] {
    return productList.filter(product =>
      questionIds?.includes(product?.productId),
    );
  }
}
